import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message", "detail", "messageHeading", "messageTitle", "messageContent", "messageEmail"]

  connect() {
    this.currentMessageId = 1
    this.showMessageById(this.currentMessageId)
  }

  showMessage(event) {
    event.preventDefault()
    const messageId = event.currentTarget.dataset.messageId
    this.currentMessageId = parseInt(messageId)
    this.showMessageById(messageId)
  }

  showMessageById(messageId) {
    this.detailTargets.forEach((detail) => {
      detail.classList.add("hidden")
    })

    const selectedDetail = this.detailTargets.find(
      (detail) => detail.dataset.messageId === messageId.toString()
    )
    if (selectedDetail) {
      selectedDetail.classList.remove("hidden")
    }

    const headingText = document.getElementById(`heading-${messageId}`).textContent
    this.messageHeadingTarget.textContent = headingText

    const titleText = document.getElementById(`title-${messageId}`).textContent
    this.messageTitleTarget.textContent = titleText

    const messageContent = document.getElementById(`content-${messageId}`).textContent
    this.messageContentTarget.textContent = messageContent

    const selectedMessage = this.messageTargets.find(
      (message) => parseInt(message.dataset.messageId) === parseInt(messageId)
    )
    if (selectedMessage) {
      const emailText = selectedMessage.dataset.email
      this.messageEmailTarget.textContent = emailText
    }

    this.setFocus(parseInt(messageId))
  }


  showNextMessage(event) {
    event.preventDefault()
    if (this.currentMessageId >= this.messageTargets.length) {
      this.currentMessageId = 1
    } else {
      this.currentMessageId++
    }
    this.showMessageById(this.currentMessageId)
    this.setFocus(this.currentMessageId)
  }

  showPreviousMessage(event) {
    event.preventDefault()
    if (this.currentMessageId <= 1) {
      this.currentMessageId = this.messageTargets.length
    } else {
      this.currentMessageId--
    }
    this.showMessageById(this.currentMessageId)
    this.setFocus(this.currentMessageId)
  }

  setFocus(messageId) {
    this.messageTargets.forEach((message) => {
      message.removeAttribute("tabindex")
    })

    const selectedMessage = this.messageTargets.find(
      (message) => parseInt(message.dataset.messageId) === messageId
    )
    if (selectedMessage) {
      selectedMessage.setAttribute("tabindex", "0")
      selectedMessage.focus()
    }
  }
}
